module.exports = __webpack_public_path__ + "img/signal_classified.png";